import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Authentication } from '../../providers/authentication';
import { ValidationService } from '../../services/validation';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap/modal/modal.module';

@Component({
  selector: 'forgot-password-modal',
  styleUrls: ['./forgot_password.scss'],
  templateUrl: './forgot_password.pug'
})

export class ForgotPasswordComponent {
  public forgotPasswordForm: FormGroup;
  private submitted: boolean;
  private forgotPasswordErrors: boolean;
  public success: boolean;

  constructor(public authService: Authentication,
              public toastr: ToastsManager,
              private router: Router,
              public activeModal: NgbActiveModal,
              private _fb: FormBuilder) {}

  ngOnInit(){
    this.forgotPasswordForm = this._fb.group(this.formInit());
  }

  formInit() {
    const user = {
      email: ['', Validators.compose([Validators.required, ValidationService.emailValidator])],
    };
    return user;
  }

  submitForm() {
    this.submitted = true;
    if(this.forgotPasswordForm.valid) {
      this.forgotPassword();
    }
  }

  forgotPassword() {
    this.authService.forgotPassword(this.forgotPasswordForm.controls['email'].value).subscribe((data) => {
      this.toastr.success('Email sent!');
      this.success = true;
    }, (err) => {
      this.forgotPasswordErrors = true;
      this.forgotPasswordForm.markAsPristine();
      this.toastr.info('Failed!');
    });
  }

  closePassword() {
    this.activeModal.close();
    this.router.navigate(['./']);
  }
}



// WEBPACK FOOTER //
// ./src/components/forgot_password/forgot_password.ts